module.exports = __webpack_public_path__ + "packs/media/images/palestraBoulder-a81643f6016834f8e6e90845e1940347.jpg";